import React from 'react';
import { Phone, MessageCircle, FileQuestion } from 'lucide-react';
export function HelpPage() {
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-196">
      <div className="bg-white sticky top-0 z-30 shadow-sm px-4 py-4" data-id="element-197">
        <h1 className="font-bold font-bengali text-xl" data-id="element-198">সাহায্য ও জিজ্ঞাসা</h1>
      </div>

      <div className="p-4 space-y-6" data-id="element-199">
        <div className="grid grid-cols-2 gap-4" data-id="element-200">
          <button className="bg-white p-6 rounded-2xl border border-gray-200 flex flex-col items-center space-y-3 shadow-sm hover:border-blue-300" data-id="element-201">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center text-blue-600" data-id="element-202">
              <Phone size={24} data-id="element-203" />
            </div>
            <span className="font-bold font-bengali text-gray-800" data-id="element-204">
              হেল্পলাইন
            </span>
          </button>

          <button className="bg-white p-6 rounded-2xl border border-gray-200 flex flex-col items-center space-y-3 shadow-sm hover:border-blue-300" data-id="element-205">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center text-green-600" data-id="element-206">
              <MessageCircle size={24} data-id="element-207" />
            </div>
            <span className="font-bold font-bengali text-gray-800" data-id="element-208">
              চ্যাট করুন
            </span>
          </button>
        </div>

        <div data-id="element-209">
          <h2 className="font-bold text-gray-900 font-bengali text-lg mb-4" data-id="element-210">
            সচরাচর জিজ্ঞাসা
          </h2>
          <div className="space-y-3" data-id="element-211">
            {['টিকিট বাতিল করব কিভাবে?', 'রিফান্ড পলিসি কি?', 'শিশুদের টিকিটের নিয়ম', 'পেমেন্ট ফেইল হলে করণীয়'].map((q, i) => <div key={i} className="bg-white p-4 rounded-xl border border-gray-200 flex justify-between items-center" data-id="element-212">
                <span className="font-medium font-bengali text-gray-700" data-id="element-213">
                  {q}
                </span>
                <FileQuestion size={18} className="text-gray-400" data-id="element-214" />
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}